import { statusTone, type SubjectStatus } from '@ni/shared';
import { subjectStatusLabel } from '../../lib/copy';

/**
 * The status marker: a small filled circle in the status's tone
 * (`statusTone`, @ni/shared), colored by `[data-tone]` in styles/status.css.
 * Color only, never shape: shapes belong to the network graph.
 */
export function StatusDot({ vertical, status }: { vertical: string; status: SubjectStatus }) {
  return <span className="status-dot" data-tone={statusTone(vertical, status)} />;
}

/**
 * A status as the office reads it: the marker and the word beside it. The word
 * is always printed, so two words sharing a tone stay distinct. A word this
 * build cannot name renders nothing, as `subjectStatusLabel` does.
 */
export function StatusWord({ vertical, status }: { vertical: string; status: SubjectStatus }) {
  const label = subjectStatusLabel(vertical, status);
  if (label === null) return null;
  return (
    <span className="status-word">
      <StatusDot vertical={vertical} status={status} />
      {label}
    </span>
  );
}
